export const formatCounterText = (
  template: string,
  valueLength: number,
  maxLength?: number,
  minLength?: number,
): string => {
  const minCharLeft =
    minLength !== undefined ? Math.max(minLength - valueLength, 0) : "";

  const maxCharLeft = maxLength !== undefined ? maxLength - valueLength : "";

  return template
    .replace(/%value/g, `${valueLength}`)
    .replace(/%maxLength/g, maxLength !== undefined ? `${maxLength}` : "")
    .replace(/%minLength/g, minLength !== undefined ? `${minLength}` : "")
    .replace(/%minCharLeft/g, `${minCharLeft}`)
    .replace(/%maxCharLeft/g, `${maxCharLeft}`);
};
